<template>
    <div class="foot">
        <div class="foot-container">
            <a-row :gutter="32">
                <a-col class="foot-row" :xl="8" :md="0" :sm="24" :xs="24">
                    <div class="foot-box1">
                        <a href="https://asiacarto.org/2024/"><img src="@/assets/asiacarto_white.png" alt="conference_logo"></a>
                    </div>
                </a-col>
                <a-col class="foot-row" :xl="8" :md="12" :sm="24" :xs="24">
                    <div class="foot-box2">
                        <h2>Contact Us</h2>
                        <p>Address: 181 Chatham Road South, Hung Hom, Hong Kong, China <br>(The Hong Kong Polytechnic University)</p>
                        <p>Email: <a class="mail" href="mailto:">asiacarto@polyu.edu.hk</a> or <a class="mail" href="mailto:">info@asiacarto.org</a></p>
                        
                    </div>
                </a-col>
                <a-col class="foot-row" :xl="8" :md="12" :sm="24" :xs="24">
                    <div class="foot-box2">
                        <h2>Social Media</h2>
                        <div>
                            <a-row class="media-row">
                                <a-col :xs="4" :sm="6"></a-col>
                                <a-col :xs="4"  :sm="3">
                                    <a href="https://x.com/carto20244259?s=21" target="_blank"><span class="iconfont icon-tuite" style="color:white;font-size:2.2rem;"></span></a>
                                </a-col>
                                <a-col :xs="4"  :sm="3">
                                    <a href="https://mp.weixin.qq.com/s/H9zpEGJzDHUhaaenfM-f3Q" target="_blank"><WechatOutlined style="color:white;font-size:2.4rem;"/></a>
                                </a-col>
                                <a-col :xs="4"  :sm="3">
                                    <a href="https://www.linkedin.com/in/asia-carto-1562342a8/" target="_blank"><LinkedinOutlined style="color:white;font-size:2.4rem;"/></a>
                                </a-col>
                                <a-col :xs="4"  :sm="3">
                                    <a href="https://www.facebook.com/profile.php?id=61554916307283" target="_blank" class="nn"><FacebookOutlined style="color:white;font-size:2.4rem;"/></a>
                                </a-col>
                                <a-col :xs="4" :sm="6"></a-col>
                            </a-row>
                        </div>
                    </div>
                </a-col>
                
            </a-row>
        </div>


    </div>
</template>

<script>
import {  WechatOutlined, LinkedinOutlined, FacebookOutlined} from '@ant-design/icons-vue';
    export default {
        components: {
            WechatOutlined,
            LinkedinOutlined,
            FacebookOutlined
        },
    }
</script>

<style lang="less" scoped>
    @import "./style.less" ;
</style>